import { getRemoteConfig } from "../../helpers";
import { logger } from "logging";


/**
 * function to fetch auto scroll timer from remote config.
 */
export const getPaymentOffersAutoScrollTimer = () => {
  let timer = 3000;
  try {
    const remoteConfig = getRemoteConfig();
    const timerFromRemoteConfig = remoteConfig?.configs?.payment?.timer?.paymentOfferScrollTimer;
    if (timerFromRemoteConfig) {
      timer = timerFromRemoteConfig;
    }
  } catch (error) {
    logger.error(new Error("Failed to load Payment offer auto scroll timer"));
  }

  return timer;
};
